<script>
	import Category from './Category.svelte';
	import Gallery from '../States/Gallery';
	import Group from './Group.svelte';

	let unblock = false;

	Gallery.load();
</script>

<style>
	div.block {
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
		background: #000;
	}
</style>

{#if unblock}
	<Category/>
	<Group/>
{:else}
	<div class="block" on:click="{event => unblock = true}"></div>
{/if}